const SAME_AS_ABOVE_TARGETS = {
  mailingsameasabove: 'mailingaddress_',
};

export function sameAsAboveProvider(config) {
  if (config.fieldType !== 'checkbox') return null;

  const key = String(config.fieldKey || config.name || '').toLowerCase();
  const match = Object.keys(SAME_AS_ABOVE_TARGETS).find(prefix => key.startsWith(prefix));
  if (!match) return null;

  const targetPrefix = SAME_AS_ABOVE_TARGETS[match];
  return {
    effects: [
      {
        when:    { field: 'self', op: 'eq', value: true },
        actions: [{ target: `${targetPrefix}*`, action: 'hide' }],
      },
    ],
  };
}